import type { I18nKey } from 'types/i18n'

import * as nombresRuta from './nombres'
import { buildBreadcrumb } from '@/@core/utils/router'
import permission, { RESOURCE_LOGISTICA_PG } from '@/auth/permissions/modules/logisticaPg'
import { defineRoutes } from '@/utils/router'

//#region helpers
const breadcrumbMantenimiento = (option: I18nKey) =>
    buildBreadcrumb('a:logistica_pg.menu_title', 'a:global.menu.mantenimiento', option)
const breadcrumbTransaccion = (option: I18nKey) =>
    buildBreadcrumb('a:logistica_pg.menu_title', 'a:global.menu.transaccion', option)
const breadcrumbConfiguracion = (option: I18nKey) =>
    buildBreadcrumb('a:logistica_pg.menu_title', 'a:global.menu.configuracion', option)
const breadcrumbInformes = (option: I18nKey) =>
    buildBreadcrumb('a:logistica_pg.menu_title', 'a:global.menu.informes', option)
//#endregion

const { mantenimiento, transacciones, informes, configuracion } = permission

export default defineRoutes([
    {
        path: '/v2/logistica/mantenimiento/gestion-choferes',
        name: nombresRuta.ROUTE_LPG_GESTION_CHOFERES,
        component: () => import('@pages/logistica-pg/mantenimiento/GestionChoferes.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_choferes',
            action: mantenimiento.gestionChoferes,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.gestion_choferes'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/crear-chofer/:id_conductor?',
        name: nombresRuta.ROUTE_LPG_CREAR_CHOFERES,
        component: () => import('@pages/logistica-pg/mantenimiento/CrearChofer.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_choferes',
            action: mantenimiento.gestionChoferes,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.gestion_choferes'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/gestion-vehiculos',
        name: nombresRuta.ROUTE_LPG_GESTION_VEHICULOS,
        component: () => import('@pages/logistica-pg/mantenimiento/GestionVehiculos.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_choferes',
            action: mantenimiento.gestionChoferes,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.gestion_choferes'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/crear-vehiculo',
        name: nombresRuta.ROUTE_LPG_CREAR_VEHICULOS,
        component: () => import('@pages/logistica-pg/mantenimiento/CrearVehiculo.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_choferes',
            action: mantenimiento.gestionChoferes,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.gestion_choferes'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/ruta-viaje',
        name: nombresRuta.ROUTE_LPG_RUTA_VIAJE,
        component: () => import('@pages/logistica-pg/mantenimiento/RutaViaje.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.ruta_viaje',
            action: mantenimiento.rutaViaje,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.ruta_viaje'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/asignacion-producto-entidad',
        name: nombresRuta.ROUTE_LPG_ASIGNACION_PRODUCTO_ENTIDAD,
        component: () => import('@pages/logistica-pg/mantenimiento/AsignacionProductoEntidad.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.asignacion_producto_entidad',
            action: mantenimiento.asignacionProductoEntidad,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.asignacion_producto_entidad'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/gestion-cuenta-logistica',
        name: nombresRuta.ROUTE_LPG_GESTION_CUENTA_LOGISTICA,
        component: () => import('@pages/logistica-pg/mantenimiento/GestionCuentaLogistica.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_cuenta_logistica',
            action: mantenimiento.gestionCuentaLogistica,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.gestion_cuenta_logistica'),
        },
    },

    /**
     * APARTADO DE TRANSACCIONES
     */
    {
        path: '/v2/logistica/transacciones/gestion-guia-movilizacion',
        name: nombresRuta.ROUTE_GESTION_GUIA_MOVILIZACION,
        component: () => import('@pages/logistica-pg/transacciones/GestionGuiaMovilizacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_guia_movilizacion',
            action: transacciones.gestionGuiaMovilizacion,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.gestion_guia_movilizacion'),
        },
    },
    {
        path: '/v2/logistica/transacciones/guia-movilizacion/:num_guia?',
        name: nombresRuta.ROUTE_GUIA_MOVILIZACION,
        component: () => import('@pages/logistica-pg/transacciones/GuiaMovilizacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.guia_movilizacion',
            action: transacciones.guiaMovilizacion,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.guia_movilizacion'),
        },
    },
    {
        path: '/v2/logistica/transacciones/gestion-alcance-hielo',
        name: nombresRuta.ROUTE_GESTION_ALCANCE_HIELO,
        component: () => import('@pages/logistica-pg/transacciones/GestionAlcanceHielo.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_alcance_hielo',
            action: transacciones.gestionAlcanceHielo,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.gestion_alcance_hielo'),
        },
    },
    {
        path: '/v2/logistica/transacciones/alcance-hielo/:num_alcance?',
        name: nombresRuta.ROUTE_ALCANCE_HIELO,
        component: () => import('@pages/logistica-pg/transacciones/AlcanceHielo.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.alcance_hielo',
            action: transacciones.alcanceHielo,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.alcance_hielo'),
        },
    },
    {
        path: '/v2/logistica/transacciones/alcance-varios/:num_alcance?',
        name: nombresRuta.ROUTE_ALCANCE_VARIOS,
        component: () => import('@pages/logistica-pg/transacciones/AlcanceVarios.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.alcance_varios',
            action: transacciones.alcanceVarios,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.alcance_varios'),
        },
    },
    {
        path: '/v2/logistica/transacciones/conciliacion-alcances',
        name: nombresRuta.ROUTE_CONCILIACION_ALCANCES,
        component: () => import('@pages/logistica-pg/transacciones/ConciliacionAlcances.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.conciliacion_alcances',
            action: transacciones.conciliacionAlcances,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.conciliacion_alcances'),
        },
    },
    {
        path: '/v2/logistica/transacciones/conciliacion-guias',
        name: nombresRuta.ROUTE_CONCILIACION_GUIAS,
        component: () => import('@pages/logistica-pg/transacciones/ConciliacionGuias.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.conciliacion_guias',
            action: transacciones.conciliacionGuias,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.conciliacion_guias'),
        },
    },
    {
        path: '/v2/logistica/transacciones/conciliacion-guias-hielo',
        name: nombresRuta.ROUTE_CONCILIACION_GUIAS_HIELO,
        component: () => import('@pages/logistica-pg/transacciones/ConciliacionGuiasHielo.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.conciliacion_guias_hielo',
            action: transacciones.conciliacionGuiasHielo,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.conciliacion_guias_hielo'),
        },
    },
    {
        path: '/v2/logistica/transacciones/aprobacion-apertura-conciliacion',
        name: nombresRuta.ROUTE_APROBACION_APERTURA_CONCILIACION,
        component: () => import('@pages/logistica-pg/transacciones/AprobacionAperturaConciliacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.aprobacion_apertura_conciliacion',
            action: transacciones.conciliacionGuiasHielo,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.aprobacion_apertura_conciliacion'),
        },
    },
    {
        path: '/v2/logistica/transacciones/cierre-masivo-conciliaciones',
        name: nombresRuta.ROUTE_CIERRE_MASIVO_CONCILIACION,
        component: () => import('@pages/logistica-pg/transacciones/CierreMasivoConciliaciones.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.cierre_masivo_conciliacion',
            action: transacciones.cierreMasivoConciliacion,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.cierre_masivo_conciliacion'),
        },
    },

    {
        path: '/v2/logistica/transacciones/gestion-conciliacion',
        name: nombresRuta.ROUTE_GESTION_CONCILIACION,
        component: () => import('@pages/logistica-pg/transacciones/GestionConciliacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.gestion_conciliacion',
            action: transacciones.gestionConciliacion,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.subopciones.gestion_conciliacion'),
        },
    },
    {
        path: '/v2/logistica/transacciones/custodio-guia-movilizacion',
        name: nombresRuta.ROUTE_CUSTODIO_GUIA_MOVILIZACION,
        component: () => import('@pages/logistica-pg/transacciones/custodio/CustodioGuiaMovilizacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.enums.custodio.custodio_guia_movilizacion',
            resource: RESOURCE_LOGISTICA_PG,
            action: transacciones.custodio.custodioGuiaMovilizacion,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.enums.custodio.custodio_guia_movilizacion'),
        },
    },
    {
        path: '/v2/logistica/transacciones/crear-custodio',
        name: nombresRuta.ROUTE_CREAR_CUSTODIO,
        component: () => import('@pages/logistica-pg/transacciones/custodio/CrearCustodio.vue'),
        meta: {
            title: 'i18n:logistica_pg.enums.custodio.crear_custodio',
            resource: RESOURCE_LOGISTICA_PG,
            action: transacciones.custodio.crearCustodio,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.enums.custodio.crear_custodio'),
        },
    },
    {
        path: '/v2/logistica/transacciones/gestion-custodio',
        name: nombresRuta.ROUTE_GESTION_CUSTODIO,
        component: () => import('@pages/logistica-pg/transacciones/custodio/GestionCustodio.vue'),
        meta: {
            title: 'i18n:logistica_pg.enums.custodio.gestion_custodio',
            resource: RESOURCE_LOGISTICA_PG,
            action: transacciones.custodio.gestionCustodio,
            breadcrumbs: breadcrumbTransaccion('logistica_pg.enums.custodio.gestion_custodio'),
        },
    },
    /**
     * APARTADO DE CONFIGURACION
     */
    {
        path: '/v2/logistica/configuracion/precio-ruta',
        name: nombresRuta.ROUTE_PRECIO_RUTA,
        component: () => import('@pages/logistica-pg/configuracion/PrecioRuta.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.precio_ruta',
            action: configuracion.alcanceHielo,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbConfiguracion('logistica_pg.subopciones.precio_ruta'),
        },
    },

    /**
     * APARTADO DE INFORMES
     */
    {
        path: '/v2/logistica/informes/reporte-guias',
        name: nombresRuta.ROUTE_REPORTE_GUIAS,
        component: () => import('@pages/logistica-pg/informes/ReporteGuiaMovilizacion.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.guia_movilizacion',
            action: informes.reporteGuias,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbInformes('logistica_pg.subopciones.guia_movilizacion'),
        },
    },
    {
        path: '/v2/logistica/informes/reporte-alcances',
        name: nombresRuta.ROUTE_REPORTE_ALCANCES,
        component: () => import('@pages/logistica-pg/informes/ReporteAlcances.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.alcance_hielo',
            action: informes.reporteAlcances,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbInformes('logistica_pg.subopciones.alcance_hielo'),
        },
    },
    {
        path: '/v2/logistica/informes/reporte-viajes-planta',
        name: nombresRuta.ROUTE_VIAJES_PLANTA,
        component: () => import('@pages/logistica-pg/informes/ReporteViajesPlanta.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.reporte_viajes_planta',
            action: informes.reporteViajesPlanta,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbInformes('logistica_pg.subopciones.reporte_viajes_planta'),
        },
    },
    {
        path: '/v2/logistica/mantenimiento/tipo-logistica',
        name: nombresRuta.ROUTE_LPG_TIPO_LOGISTICA,
        component: () => import('@pages/logistica-pg/mantenimiento/TipoLogistica.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.mantenimiento.tipo_logistica',
            action: mantenimiento.tipoLogistica,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbMantenimiento('logistica_pg.subopciones.reporte_tipo_logistica'),
        },
    },
    {
        path: '/v2/logistica/informes/distributivo-pago-logistico',
        name: nombresRuta.ROUTE_DISTRIBUTIVO_PAGO_LOGISTICO,
        component: () => import('@pages/logistica-pg/informes/DistributivoPagoLogistico.vue'),
        meta: {
            title: 'i18n:logistica_pg.subopciones.distributivo_pago',
            action: informes.distributivoPagoLogistico,
            resource: RESOURCE_LOGISTICA_PG,
            breadcrumbs: breadcrumbInformes('logistica_pg.subopciones.distributivo_pago'),
        },
    },
])
